import { useSearchParams } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { useState } from "react";

const DailyPracticeTest = () => {

    const [filter1,setFilter1]=useState()
    const [filter2,setFilter2]=useState()
    const [filter3,setFilter3]=useState()
   
    return (
        <>
            {/* <SectionSidebar /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item">
                            <span>Home</span>
                        </li>
                       
                        <li className="breadcrumb-item active"><span>Daily Practice Test</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i>Daily Practice Test</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Filter:</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={(e)=>setFilter1(e.target.value)} value={filter1}>
                                                        <option selected value={''} disabled>[Select Filter]</option>
                                                        <option  value={'Studentwise'} >Studentwise</option>
                                                        <option  value={'Classwaise'} >Classwaise</option>
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Filter:</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={(e)=>setFilter2(e.target.value)} value={filter2}>
                                                        <option selected value={''} disabled>[Select Filter]</option>
                                                        <option  value={'Subjectwise'} >Subjectwise</option>
                                                        <option  value={'Allsubject'} > Allsubject</option>
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Filter:</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={(e)=>setFilter3(e.target.value)} value={filter3}>
                                                        <option selected value={''} disabled>[Select Filter]</option>
                                                        <option  value={'ConsolidateReport'} >ConsolidateReport</option>
                                                        <option  value={'Details'} >Details</option>
                                                    </select>

                                                </div>

                                            </div>

                                            <div className="row">

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setFilter1(''); setFilter2(''); setFilter3(''); }}>Reset</button>
                                                    </div>
                                                </div>
                                               

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        {filter1=='Studentwise' &&<th scope="col">Student Name</th>}
                                                                        {filter1=='Classwaise' &&<th scope="col">Class</th>}
                                                                        {filter2=='Allsubject' &&<th scope="col">AllSubject</th>}
                                                                        {filter2=='Subjectwise' &&<th scope="col">Subject 1</th>}
                                                                        {filter2=='Subjectwise' &&<th scope="col">Subject 2</th>}
                                                                        {filter2=='Subjectwise' &&<th scope="col">Subject 3</th>}
                                                                        {filter2=='Subjectwise' &&<th scope='col'>Subject 4</th>}
                                                                        {filter3=='ConsolidateReport' &&<th scope="col">ConsolidateReport</th>}
                                                                        {filter3=='Details' &&<th scope="col">Details</th>}
                                                                    </tr>
                                                                </thead>
                                                                {/* <tbody>
                                                                    {
                                                                        teacherList.length > 0 ?
                                                                            teacherList.map((section, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td>{section.teacherName}</td>
                                                                                        <td>{section.email}</td>
                                                                                        <td>{dateFormate(section.joiningDate)}</td>
                                                                                        <td>{dateFormate(section.dob)}</td>
                                                                                        <td>{section.contactNumber}</td>
                                                                                        <td>{section.gender}</td>
                                                                                        <td>{section.qualification}</td>
                                                                                        <td>{section.address}</td>
                                                                                        <td>{section.sectionMasterDetails.sectionName}</td>
                                                                                        <td>
                                                                                         

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Teacher Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody> */}
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default DailyPracticeTest;